export class QuestionCodeAnswer {
    id: number;
    answer: string;
    name:string;
}


// WEBPACK FOOTER //
// ./src/app/models/questionCodeAnswer.ts